module.exports = __webpack_public_path__ + "static/media/mobile_app.4a18fda0.png";